'use strict';

var raven = require('raven-js');

module.exports = {
  init: function(dsn) {
    if(dsn) {
      raven.config(dsn).install();
    }
    return this;
  },

  setUser: function(userId) {
    if(userId) {
      raven.setUser({ id: userId });
      console.info('Sentry set user ID: ' + userId);
    }
    return this;
  },

  analytics: function() {
    return raven;
  }
};
